export default [
    {
        path: '/acl/user-list',
        name: 'acl_user_list',
        component: () => import('@src/acl/user-list'),
        meta: {
            title: 'Benutzer',
            role: 'ROLE_EDIT_USER_ROLES',
        },
    },
    {
        path: '/acl/user-roles/:idUser',
        name: 'acl_edit_user_roles',
        component: () => import('@src/acl/edit-user-roles'),
        props(route) {
            const props = {};
            props.id = Number.parseInt(route.params.idUser);

            return props;
        },
        meta: {
            role: 'ROLE_EDIT_USER_ROLES',
        },
    },
];
